import { format as formatDateFns, parse, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { ptBR, es } from "date-fns/locale";
import { formatDistanceToNow } from "date-fns";

export const DATE_LOCALES = { pt: ptBR, es };

const DEFAULT_TIMEZONE = "America/Sao_Paulo";

const zoned = (date, timezone) => toZonedTime(parseISO(date), timezone);

export default function formatDate(
  date,
  timezone = DEFAULT_TIMEZONE,
  formatStr = "ddMMyyyy"
) {
  if (!date) return "";
  return formatDateFns(zoned(date, timezone), formatStr, { locale: ptBR });
}

export const newDate = (string, format = "ddMMyyyy") => {
  return parse(string, format, new Date());
};

export const fromNow = (date, timezone = DEFAULT_TIMEZONE, locale = ptBR) => {
  if (!date) return "";
  return formatDistanceToNow(zoned(date, timezone), {
    addSuffix: true,
    locale,
  });
};

export const parseToDate = (
  dateStr,
  formatStr = "ddMMyyyy",
  referenceDate = new Date()
) => {
  return parse(dateStr, formatStr, referenceDate);
};

export const formatDateTime = (date, timezone = DEFAULT_TIMEZONE) => {
  if (!date) return "";
  return formatDateFns(zoned(date, timezone), "dd/MM/yyyy - HH:mm", {
    locale: ptBR,
  });
};
